/**
 * Rangée KPI cliquable — Parc Matériels V2.
 * « À traiter » est un agrégat de filtre, jamais un badge device.
 */
export default function MaterielKpiRow({
  kpis = { total: 0, affectes: 0, enStock: 0, aTraiter: 0 },
  activeKpi = null,
  onSelect,
  loading = false,
}) {
  const cards = [
    {
      id: 'total',
      label: 'Matériels',
      value: kpis.total,
      hint: 'Parc chargé',
    },
    {
      id: 'affectes',
      label: 'Affectés',
      value: kpis.affectes,
      hint: 'Points de vente',
    },
    {
      id: 'en_stock',
      label: 'En stock',
      value: kpis.enStock,
      hint: 'Disponibles',
    },
    {
      id: 'a_traiter',
      label: 'À traiter',
      value: kpis.aTraiter,
      hint: 'Erreur ou à vérifier',
    },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
      {cards.map((card) => {
        const active = activeKpi === card.id;
        return (
          <button
            key={card.id}
            type="button"
            disabled={loading}
            onClick={() => onSelect?.(card.id)}
            aria-pressed={active}
            className={`text-left rounded-lg border px-4 py-3 transition-colors focus:outline-none focus:ring-2 focus:ring-primary-500 ${
              active
                ? 'border-primary-300 bg-primary-50'
                : 'border-gray-200 bg-white hover:border-primary-200 hover:bg-gray-50'
            } ${loading ? 'opacity-60 cursor-wait' : ''}`}
          >
            <p className="text-xs font-medium text-gray-500 uppercase tracking-wide">
              {card.label}
            </p>
            <p className="mt-1 text-2xl font-semibold text-gray-900 tabular-nums">
              {loading ? '—' : card.value}
            </p>
            <p className="mt-0.5 text-xs text-gray-400">{card.hint}</p>
          </button>
        );
      })}
    </div>
  );
}
